import { render, staticRenderFns } from "./shopList.vue?vue&type=template&id=721c8c78&scoped=true"
import script from "./shopList.vue?vue&type=script&lang=ts"
export * from "./shopList.vue?vue&type=script&lang=ts"
import style0 from "./shopList.vue?vue&type=style&index=0&id=721c8c78&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721c8c78",
  null
  
)

export default component.exports